import MoveToFolder from './MoveToFolder';

export default MoveToFolder;
